import styled from '@emotion/styled';
import { Typography } from '@mui/material';
import { ReactNode } from 'react';

const DiscountTypeContainer = styled('div')(() => ({
  backgroundColor: '#F2EFF5',
  marginTop: '5px',
  padding: '1px 6px',
  width: 'fit-content',
}));

const DiscountTypography = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'bold',
})<{ bold?: boolean }>(({ bold }) => ({
  color: '#5D5FEF',
  fontFamily: 'Poppins',
  fontWeight: bold ? 500 : 400,
  fontSize: '12px',
  lineHeight: '19px',
  letterSpacing: '2%',
}));

const DISCOUNT_TYPES = {
  EXPIRATION: 'EXPIRATION',
  MEKI: 'MEKI',
};

const discountText = (type: string): ReactNode => {
  switch (type) {
    case DISCOUNT_TYPES.EXPIRATION:
      return (
        <DiscountTypography bold={false}>
          Descuento por vencimiento entre 2 y 6 meses
        </DiscountTypography>
      );

    default:
      return null;
  }
};

export {
  discountText,
  DiscountTypography,
  DiscountTypeContainer,
  DISCOUNT_TYPES,
};
